import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, withTypes } from 'react-final-form';
import { useLocation } from 'react-router-dom';
import { Snackbar, Button, Card, Typography, CircularProgress, TextField, Box, useMediaQuery, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Alert from '@material-ui/lab/Alert';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
import { Notification, useTranslate } from 'react-admin';
import { lightTheme } from './themes';
import mainLogo from '../assets/logo2.png'
import { red, pink } from '@material-ui/core/colors';
import { useDataProvider } from 'react-admin';
import { useHistory } from 'react-router-dom';
import emailSend from '../assets/mailsend.png'


const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    conainer: {
        minHeight: '100vh',
        backgroundImage: 'url(/images/hopital-bg.jpg)'
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
    },
    card: {
        margin: 'auto',
        [theme.breakpoints.up('xs')]: {
            padding: '3em 3em'
        },
        [theme.breakpoints.down('xs')]: {
            padding: '3em 1em'
        },
    },
    notchedOutline: {
        borderWidth: "1px",
        borderColor: "yellow !important"
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
    text: {
        color: 'white',
        lineHeight: '0',
        fontWeight: 'bold'
    },
    h1: {
        background: '-webkit-linear-gradient(blue, green)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    }, TitleConfirmEmail: {
        fontFamily: 'UniviaPro',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    ConstentConfirmEmail: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    btnBackLogin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
    }, btnSignin: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: "#ffffff"
    },
}));


const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    ...props
}) => {
    return (
        <TextField
            error={!!(touched && error)}
            helperText={touched && error}
            {...inputProps}
            {...props}
            color='primary'
            fullWidth
            InputProps={{
                style: {
                    fontFamily: 'UniviaPro',
                    fontSize: '13px',
                    fontWeight: 'normal',
                    fontStretch: 'normal',
                    fontStyle: 'normal',
                    lineHeight: 1.85,
                    letterSpacing: ' 0.13px',
                    color: "#4f5064",
                }
            }}
        />
    )
};



interface FormValues {
    repeatpassword?: string;
    password?: string;
}

const { Form } = withTypes<FormValues>();

const ForceUser = () => {

    const [isError, setIsError] = useState(true);
    const [openAlert, setOpenAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const translate = useTranslate();
    const classes = useStyles();
    const [notification, setNotification] = useState("")
    const isXsmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));
    const dataProvider = useDataProvider();
    const history = useHistory();
    const [openDialog, setOpenDialog] = useState(false);


    const handleSubmit = (values: FormValues) => {
        const change = localStorage.getItem('id')
        dataProvider('UPDATE', 'users', {
            id: change,
            data: {
                forceChangePassword: false,
                password: values.password
            }
        }).then(({ users }: any) => {
            setIsSend(true)
        }).catch((response: Error) => {
            setLoading(false);
            setNotification(
                translate(response.message)
            );
        });

    };

    const handelBackLogin = () => {
        history.push('/login');
        setMessage("")
        setNotification("")
    }


    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const validate = (values: FormValues) => {
        const errors: FormValues = {};
        if (!values.repeatpassword) {
            errors.repeatpassword = translate('ra.validation.required');
        }
        else if (values.repeatpassword != values.password) {
            errors.repeatpassword = translate('pos.auth.checkrepeatpassword');
        }
        if (!values.password) {
            errors.password = translate('ra.validation.required');
        }

        setIsError(errors.password || errors.repeatpassword ? true : false)

        return errors;
    };

    return (
        <div className={classes.conainer}>
            <div className={classes.main}>
                <Form
                    onSubmit={handleSubmit}
                    validate={validate}
                    render={({ handleSubmit }) => (

                        <form onSubmit={handleSubmit} noValidate>
                            <Box>
                                <Card className={classes.card}>
                                    <Box justifyContent='center'>
                                        <Box width='100%' textAlign='center'>
                                            <img src={mainLogo} width='206px' height='48px' />
                                        </Box>
                                        {
                                            isSend ? (
                                                <Box width={400} textAlign='center'>
                                                    <Box display='flex' justifyContent='center' width='100%' mt={2}>
                                                        <img src={emailSend} width="230" height="230" />
                                                    </Box>
                                                    <Typography style={{ paddingBottom: '8px' }} className={classes.TitleConfirmEmail}>{translate('pos.auth.confirmEmail')}</Typography>
                                                    <Typography className={classes.ConstentConfirmEmail}>{translate('pos.auth.confirmEmailConstent')}</Typography>
                                                    <Button
                                                        color='primary'
                                                        size='large'
                                                        onClick={() => {
                                                            handelBackLogin()
                                                            setIsSend(false)

                                                        }}
                                                        style={{ marginTop: '16px' }} className={classes.btnBackLogin}>{translate('pos.auth.backtologin')}</Button>

                                                </Box>
                                            ) :
                                                (
                                                    <Box>
                                                        <Box my={3}>
                                                            {
                                                                notification != "" &&
                                                                (
                                                                    <Box borderRadius='6px' my={1} width={isXsmall ? 300 : 400} bgcolor={bgColorError} py={1}>
                                                                        <Typography className={classes.ConstentConfirmEmail} style={{ color: textColorError, margin: '1em' }}>{notification}</Typography>
                                                                    </Box>
                                                                )
                                                            }

                                                            <Typography className={classes.TitleConfirmEmail} >{translate(`pos.auth.Titleforceuser`)}</Typography>
                                                            <Typography style={{ cursor: 'pointer' }} className={classes.ConstentConfirmEmail} >{translate(`pos.auth.forcetitle`)}</Typography>
                                                            <Typography style={{ cursor: 'pointer' }} className={classes.ConstentConfirmEmail} >{translate(`pos.auth.titleforce`)}</Typography>
                                                        </Box>
                                                        <Box my={3}>
                                                            <Field
                                                                name="password"
                                                                // @ts-ignore
                                                                component={renderInput}
                                                                label={translate(`pos.auth.newpassword`)}
                                                                style={{ width: isXsmall ? 300 : 400 }}
                                                                disabled={loading}
                                                                type={showPassword ? 'text' : 'password'}
                                                                InputProps={{
                                                                    endAdornment: <InputAdornment position="end">
                                                                        {
                                                                            !isError ? (
                                                                                <IconButton
                                                                                    size='small'
                                                                                    aria-label="toggle password visibility"
                                                                                    onClick={handleClickShowPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                >
                                                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                                </IconButton>
                                                                            ) : <div></div>
                                                                        }

                                                                    </InputAdornment>
                                                                }}
                                                            />
                                                        </Box>
                                                        <Box my={3}>
                                                            <Field
                                                                name="repeatpassword"
                                                                // @ts-ignore
                                                                component={renderInput}
                                                                label={translate(`pos.auth.repeatnewpasssword`)}
                                                                style={{ width: isXsmall ? 300 : 400 }}
                                                                disabled={loading}
                                                                type={showPassword ? 'text' : 'password'}
                                                                InputProps={{
                                                                    endAdornment: <InputAdornment position="end">
                                                                        {
                                                                            !isError ? (
                                                                                <IconButton
                                                                                    size='small'
                                                                                    aria-label="toggle password visibility"
                                                                                    onClick={handleClickShowPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                >
                                                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                                </IconButton>
                                                                            ) : <div></div>
                                                                        }

                                                                    </InputAdornment>
                                                                }}

                                                            />
                                                        </Box>
                                                        <Box width='100%' display='flex' justifyContent='flex-end'>
                                                            <Button
                                                                variant="contained"
                                                                type="submit"
                                                                color="primary"
                                                                disabled={loading || isError}
                                                            >
                                                                {loading && (
                                                                    <CircularProgress
                                                                        size={25}
                                                                        thickness={2}
                                                                        color='inherit'
                                                                    />
                                                                )}
                                                                <Typography className={classes.btnSignin}>{translate(`pos.auth.submitpassword`)}</Typography>
                                                            </Button>
                                                        </Box>

                                                    </Box>
                                                )
                                        }

                                    </Box>
                                </Card>
                                <Notification />

                            </Box>

                            <Snackbar open={openAlert} autoHideDuration={6000} onClose={() => setOpenAlert(false)}>
                                <Alert onClose={() => setOpenAlert(false)} severity={isSend ? "success" : "error"}>{message}</Alert>
                            </Snackbar>
                        </form>
                    )}
                />
            </div>
        </div>
    );
};

ForceUser.propTypes = {
    authProvider: PropTypes.func,
    previousRoute: PropTypes.string,
};

// We need to put the ThemeProvider decoration in another component
// Because otherwise the useStyles() hook used in Login won't get
// the right theme
const LoginWithTheme = (props: any) => (
    <ThemeProvider theme={createMuiTheme(lightTheme)}>
        <ForceUser {...props} />
    </ThemeProvider>
);

export default LoginWithTheme;
